(function () {
  function getSelectedEvent() {
    try {
      const params = new URLSearchParams(window.location.search);
      const value = params.get('event');
      return value ? String(value) : null;
    } catch (error) {
      return null;
    }
  }

  function applyVisibility(root) {
    const scope = root || document;
    const selected = getSelectedEvent();
    const sections = Array.from(scope.querySelectorAll('[data-event-detail]'));

    if (!sections.length) return;
    if (!selected) return;

    sections.forEach((section) => {
      if (section.dataset.eventIndex === selected) {
        section.removeAttribute('hidden');
      } else {
        section.setAttribute('hidden', 'hidden');
      }
    });
  }

  function init(root) {
    applyVisibility(root);
  }

  document.addEventListener('DOMContentLoaded', () => init());

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
